export default __webpack_public_path__ + "static/media/oct2023-2.ce919bfc.jpeg";